import AbstractTrackingAdapter, { Revenue } from './AbstractTrackingAdapter';
import ReactGA from 'react-ga';

export default class GoogleAnalyticsAdapter extends AbstractTrackingAdapter {
  logEvent = (eventName: string, eventProperties: any) => {
    ReactGA.event({
      category: 'User',
      action: eventName
    });
  };

  revenue = ({ productId, amount, properties = {} }: Revenue) => {
    ReactGA.plugin.execute('ecommerce', productId, {
      ...properties,
      revenue: amount
    });
  };

  setUser = (user: any) => {
    ReactGA.set({ userId: user.id });
  };
}
